@if (message()) {
  <p class="message">{{ message() }}</p>
}

@if (showStartButton()) {
  <p>
    <button type="button" (click)="startClick.emit()">Get started</button>
  </p>
}
